<template>
  <v-container id="fcreate" fluid>
    <v-row>
      <v-col cols="12">
        <v-form ref="form" v-model="valid">
          <v-container fluid>
            <v-row>
              <!-- Название -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.name"
                  label="Название"
                  outlined
                  required
                  :rules="rules.required"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="12" md="7">
                <regions-select-fields
                  v-model="data.regions"
                  label="Доступно в регионах"
                  empty-text="Доступно во всех регионах"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>

              <v-col cols="12">
                <regions-select-fields
                  v-model="data.regionsExclude"
                  label="Не доступно в регионах"
                  empty-text="Нет исключенных регионов"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>

              <!-- Цвет фона -->
              <v-col cols="12" md="7">
                <v-menu
                  v-model="menu"
                  nudge-bottom="105"
                  nudge-left="16"
                  top
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="data.color"
                      label="Цвет фона"
                      outlined
                      v-on="on"
                    />
                  </template>
                  <v-card>
                    <v-card-text class="pa-0">
                      <v-color-picker v-model="data.color" mode="hexa" flat />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-col>
              <!-- Изображения для десктопа -->
              <v-col
                cols="12"
                md="7"
              >
                <upload-image
                  v-model="data.desktopImage"
                  color="orange"
                  label="Загрузить фото"
                >
                  Изображения для десктопа
                </upload-image>
              </v-col>
              <!-- Изображение для мобильных устройств -->
              <v-col
                cols="12"
                md="7"
              >
                <upload-image
                  v-model="data.mobileImage"
                  color="orange"
                  label="Загрузить фото"
                >
                  Изображение для мобильных устройств
                </upload-image>
              </v-col>
              <!-- Ссылка -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.link"
                  label="Ссылка"
                  outlined
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- Цель -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.target"
                  label="Цель"
                  outlined
                  required
                  :rules="rules.required"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- Сортировка -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.sortOrder"
                  label="Индекс сортировки"
                  outlined
                  required
                  :rules="rules.requiredNumber"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- Submit -->
              <v-col cols="12" md="7">
                <v-row>
                  <v-col cols="4">
                    <v-btn
                      block
                      :loading="loading"
                      :disabled="loading"
                      large
                      @click.prevent="$router.push('/slider')"
                    >
                      Отмена
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      class="mb-2"
                      block
                      color="info"
                      :loading="loading"
                      :disabled="loading"
                      large
                      @click.prevent="save(false)"
                    >
                      Применить
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      block
                      class="mb-2"
                      color="success"
                      :loading="loading"
                      :disabled="loading"
                      large
                      @click.prevent="save"
                    >
                      Сохранить
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import rules from '@/mixins/rules'
  import RegionsSelectFields from '@/components/ui/crud/fields/RegionsSelectField.vue'

  export default {
    components: { RegionsSelectFields },
    mixins: [rules],
    data () {
      return {
        data: {
          name: '',
          color: '',
          desktopImage: '',
          mobileImage: '',
          link: '',
          target: 'home',
          sortOrder: 1,
          status: true,
          regions: [],
          regionsExclude: [],
        },
        loading: false,
        valid: false,
        snackbar: false,
        snackbarSuccess: false,
        mask: '!#XXXXXXXX',
        menu: false,
      }
    },
    async created () {
      const id = this.$route.params.id
      if (id) {
        try {
          const res = await this.$store.dispatch('slider/fetchSingleSlider', id)
          if (res.status === 200) {
            this.data = res.data.data
            this.data.regions = res.data.data.regions.map(item => item.id)
            this.data.regionsExclude = res.data.data.regionsExclude.map(item => item.id)
          }
        } catch (e) { console.log(e) }
      } else {
        this.$router.push('/slider')
      }
    },
    methods: {
      async save (redirect = true) {
        const validate = await this.$refs.form.validate()

        if (validate) {
          try {
            const res = await this.$store.dispatch('slider/editSlider', { data: this.data, id: this.$route.params.id })
            if (res.status === 200 && redirect) {
              this.$router.push('/slider')
            } else {
              this.snackbarSuccess = true
              setTimeout(() => {
                this.snackbarSuccess = false
              }, 3000)
            }
          } catch (e) { console.log(e) }
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
